<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-sm-12 container-actions-buttons">
      <button type="button" class="mb-2 btn btn-light" (click)="updateRtnFiscalId()">Actualizar RTN</button>
      <button *appHasAccess="'addPAC'" type="button" class="mb-2 btn btn-light" (click)="handlePacClick()">Ingresar
        PAC</button>

      <button *appHasAccess="'agreement'" type="button" class="mb-2 btn btn-light" (click)="handleCvnClick()">Ingresar
        Convenio</button>
      <button *ngIf="showConvenio()" type="button" class="mb-2 btn btn-light" (click)="handle30daysClick()">Ingresar 30
        dias</button>
      <button *appHasAccess="'raiseLimit'" [hidden]="!this.currentCustomerCreditConditions.creditLineActive"
        (click)="handleRaiseLimitClick()" type="button" class="btn btn-light mb-2 w-100">Aumentar Limites</button>
      <button type="button" class="mb-2 btn btn-light" appPrivilege="showViewAdvance"
        (appPrivilegeClick)="toAdvance()">Anticipos</button>
      <button type="button" class="mb-2 btn btn-light" (click)="handleInvoiceClick()">Facturar</button>
      <button type="button" class="mb-2 btn btn-light" (click)="handleQuotationCvnClick()">Cotizar Convenio</button>
      <button type="button" class="mb-2 btn btn-light" (click)="handleBalanceRecordPrintClick()">Imprimir Constancia de
        Saldos</button>
      <button type="button" class="mb-2 btn btn-light" (appPrivilegeClick)="handleCreditReferenceClick()"
        appPrivilege="createCreditReference">Referencia
        Crediticia</button>

    </div>
  </div>
</div>